export default {
  LOGIN_ENTER_PHONE: 'LOGIN_ENTER_PHONE',
  LOGIN_ENTER_OTP: 'LOGIN_ENTER_OTP',
  ELM_ENTER_ID: 'ELM_ENTER_ID',
  ELM_ENTER_OTP: 'ELM_ENTER_OTP',
  CONFIRMATION: 'CONFIRMATION',
  FINISH: 'FINISH',
}
